/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as GraphDefs from './defs.defs'

const $nsid = 'app.bsky.graph.getStarterPacks'

type $nsid = typeof $nsid

export { $nsid }

export const $params = /*#__PURE__*/ l.params({
  uris: /*#__PURE__*/ l.array(/*#__PURE__*/ l.string({ format: 'at-uri' }), {
    maxLength: 25,
  }),
})

export type $Params = l.InferOutput<typeof $params>

export const $output = /*#__PURE__*/ l.jsonPayload({
  starterPacks: /*#__PURE__*/ l.array(
    /*#__PURE__*/ l.ref<GraphDefs.StarterPackViewBasic>(
      (() => GraphDefs.starterPackViewBasic) as any,
    ),
  ),
})

export type $Output<B = l.BinaryData> = l.InferPayload<typeof $output, B>
export type $OutputBody<B = l.BinaryData> = l.InferPayloadBody<
  typeof $output,
  B
>

/** Get views for a list of starter packs. */
const main = /*#__PURE__*/ l.query($nsid, $params, $output)

export { main }

const $lxm = $nsid

type $lxm = typeof $lxm

export { $lxm }
